import React from 'react';
import loadable from '@loadable/component';
import CloseIcon from '../icons/close';

const Transition = loadable(() => import('@headlessui/react').then(m => m.Transition), { ssr: true });
const TransitionChild = loadable(() => import('@headlessui/react').then(m => m.Transition.Child), { ssr: true });
const HeadlessDialog = loadable(() => import('@headlessui/react').then(m => m.Dialog), { ssr: true });
const DialogPanel = loadable(() => import('@headlessui/react').then(m => m.Dialog.Panel), { ssr: true });

function Dialog({ open, onClose, maxWidth = '75%', children }) {
	return (
		<Transition appear show={open}>
			<HeadlessDialog as="div" className="relative z-50" onClose={onClose}>
				<TransitionChild
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-black/50" />
				</TransitionChild>

				<div className="fixed inset-0 overflow-y-auto">
					<div className="flex min-h-full items-center justify-center p-4 text-center">
						<TransitionChild
							enter="ease-out duration-300"
							enterFrom="opacity-0 scale-95"
							enterTo="opacity-100 scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 scale-100"
							leaveTo="opacity-0 scale-95"
						>
							<DialogPanel
								className="relative w-full transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all"
								style={{ maxWidth }}
							>
								<button
									type="button"
									className="absolute right-4 top-4 flex items-center justify-center w-10 h-10 rounded-full hover:bg-aqua-haze"
									onClick={onClose}
									aria-label="Close"
								>
									<CloseIcon size="w-3.5 h-3.5" color="text-shuttle-grey" />
								</button>
								{children}
							</DialogPanel>
						</TransitionChild>
					</div>
				</div>
			</HeadlessDialog>
		</Transition>
	);
}

export default Dialog;
